import createAssessment from './createAssessment';
import companies from './companies';
import programs from './programs';
import teams from './teams';
import errors from './errors';
import contacts from './contacts';
import {combineReducers} from 'redux';
import {handleAction} from 'redux-actions';
import reduceReducers from 'reduce-reducers';

const logout = handleAction('LOGOUT', () => undefined, {});

export default reduceReducers(
  combineReducers({
    createAssessment,
    companies,
    teams,
    programs,
    contacts,
    errors
  }),
  logout,
  {}
);


// WEBPACK FOOTER //
// ./src/components/utils/reducers/index.js